import styled, { keyframes } from "styled-components";
import Sun from "../icons/sun_on.svg?react";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

/**
 * Small inline "spinning sun" for in-button busy states — sized to the text
 * line (1.15em) so it can sit inside a control without changing its footprint.
 * Decorative: the busy state is conveyed to assistive tech via the button's
 * aria-busy / aria-label, so the sun is aria-hidden.
 */
const Sizer = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  svg {
    width: 1.15em;
    height: 1.15em;
    animation: ${spin} 1s linear infinite;
    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  }
`;

export function InlineSunSpinner() {
	return (
		<Sizer aria-hidden="true">
			<Sun />
		</Sizer>
	);
}

export default InlineSunSpinner;
